export const geocodeAddress = (
  value: string
): Promise<google.maps.LatLngLiteral | null> => {
  return new Promise((resolve) => {
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: value }, (results, status) => {
      if (status === "OK" && results && results[0]) {
        const location = results[0].geometry.location;
        resolve({ lat: location.lat(), lng: location.lng() });
      } else {
        resolve(null);
      }
    });
  });
};

export const distanceInMetersBetween = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
) => {
  if (
    typeof google !== "undefined" &&
    google.maps &&
    google.maps.geometry &&
    google.maps.geometry.spherical &&
    typeof google.maps.geometry.spherical.computeDistanceBetween === "function"
  ) {
    const point1 = new google.maps.LatLng(lat1, lng1);
    const point2 = new google.maps.LatLng(lat2, lng2);

    const distanceInMeters =
      google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
    return distanceInMeters;
  }

  // fallback — calculation using the haversine formula
  const toRadians = (deg: number) => (deg * Math.PI) / 180;
  const R = 6371e3;
  const φ1 = toRadians(lat1);
  const φ2 = toRadians(lat2);
  const Δφ = toRadians(lat2 - lat1);
  const Δλ = toRadians(lng2 - lng1);

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

export const metersToLabel = (meters: number) => {
  if (meters < 1000) {
    return `${meters.toFixed()} m`;
  }

  return `${(meters / 1000).toFixed(1)} km`;
};
